


























import Vue from 'vue'

export default Vue.extend({
  name: 'EmployeePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    employees: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number,
      default: null
    },
    dark: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  }
})
